
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'variant-checkbox',
  props: {
    label: { type: String, required: true },
    index: { type: Number, required: true },
    checkbox: Boolean,
  },
  methods: {
    changeValue() {
      this.$emit('update:checkbox', !this.checkbox)
    },
  },
  computed: {
    character(): string {
      return String.fromCharCode(97 + this.index).toUpperCase()
    },
  },
})
